<template>
<v-card color='grey lighten-4' >
  <v-progress-linear
    :height="2" indeterminate v-if='statementRequest.loading'
    class='ma-0 pa-0' >
  </v-progress-linear>
  <v-layout>
    <v-navigation-drawer bottom touchless hide-overlay width='420'
      :absolute="$vuetify.breakpoint.xs"
      :permanent="!$vuetify.breakpoint.xs"
      v-model='drawer' >
      <v-card flat height='100%' >
        <active-clients
          :with-close='$vuetify.breakpoint.xs'
          @selected='setSelectedClient'
          @close='drawer=false' >
        </active-clients>
      </v-card>
    </v-navigation-drawer>
    <v-flex xs12 style='min-height:600px;'  >
      <!-- <v-toolbar dense flat dark >
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-select
          v-model="statusFilters"
          :items="['New', 'Custom', 'Invoiced', 'Paid']"
          attach chips multiple
          label="Filter"
        ></v-select>
        <v-select
          v-model="excludeFilters"
          :items="['New', 'Custom', 'Invoiced', 'Paid']"
          attach chips multiple
          label="Exclude"
        ></v-select>
      </v-toolbar> -->
      <!-- @action = 'actionClicked'
      :action-items='actionItems' -->
      <statement
        v-if='selectedClient && selectedClient.id'
        @prev = 'activeIndex--'
        @next = 'activeIndex++'
        @dateRangeChangeRequested = 'launchDateRangePicker'
        @reload = 'getStatement'
        @selected:list = 'updateSelectedAppointments'
        v-model='statement'
        :is-compact='$vuetify.breakpoint.xs'
        :with-filters='false'
        :client='selectedClient'
        :filter-from-date='this.globalActiveDateRange.from'
        :filter-to-date='this.globalActiveDateRange.to'
        :with-selectable = 'true'
        :with-reload = 'true'
        :with-pre-next = 'false'
        :loading='statementRequest.loading' >

        <v-toolbar-side-icon class='hidden-sm-and-up' slot='toolbar-icon' @click='drawer=!drawer' >
        </v-toolbar-side-icon>
      </statement>
      <v-card v-else flat >
        <v-card-text class='subheading' >
          Choose a customer to view a summary of their appointments between <br/>
          <strong>{{globalActiveDateRangeFormatted}}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small flat @click='launchDateRangePicker' >Change dates</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>

</v-card>
</template>

<script>

import AppointmentMixins from '@/mixins/appointments'
import Statement from '@/components/statement'
import ActiveClients from '@/components/client/ActiveClients'
export default {
  name: 'FinancialsPage',
  mixins: [AppointmentMixins],
  components: {
    Statement,
    ActiveClients
  },
  data () {
    return {
      drawer: true,
      actionItems: [
        'appointment_codes',
        'show_payment'
      ],
      statusFilters: [],
      excludeFilters: [],
      appointment: {},
      selectedAppointments: [],
      selectedClient: {},
      activeIndex: -1,
      statementRequestId: 'statement-detail-request'
    }
  },
  computed: {
    activeClientParams () {},
    statementRequest () {
      return this.$store.getters.getRequestById(this.statementRequestId, true)
    },
    statement () {
      return this.getObjectPath(this.statementRequest, 'result.data', {})
    },
    baseParams () {
      return {
        from_date: this.globalActiveDateRange.from,
        to_date: this.globalActiveDateRange.to
      }
    },
    menuItems () {
      return this.getAppointmentActionItemsByKeyList(this.actionItems)
    }
  },
  watch: {
    activeIndex () {
      this.getStatement()
    },
    globalActiveDateRangeFormatted () {
      this.getStatement()
    }
  },
  methods: {
    setSelectedClient (relationship, index) {
      this.selectedClient = relationship
      this.activeIndex = index
      if (this.$vuetify.breakpoint.xs) {
        this.drawer = false
      }
    },
    getStatement (params) {
      if (!params) {
        params = this.baseParams
      }
      this.selectedAppointments = []
      this.$appointmentguru
        .resource('v3.statement')
        .id(this.statementRequestId)
        .get(this.selectedClient.client.id, params)
    },
    actionClicked (action, appointment) {
      appointment.client = this.selectedClient
      this.appointment = appointment
      action.onclick(appointment)
    },
    updateSelectedAppointments (selected) {
      this.selectedAppointments = selected
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Financials.vue?e9e3cbe8